const ResetPasswordConstants = {
	RESET_REQUEST: 'RESET_REQUEST',
	RESET_SUCCESS: 'RESET_SUCCESS',
	RESET_FAILURE: 'RESET_FAILURE',
}

export default ResetPasswordConstants;
